import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { Entrevista } from '../entrevista/entrevista';
import { EntrevistaService } from '../entrevista/entrevista.service';

import { URL_API } from './../constante';

@Component({
  selector: 'app-entrevista',
  templateUrl: './entrevista.component.html',
  styleUrls: ['./entrevista.component.css'],
  providers: [ EntrevistaService ]
})
export class EntrevistaComponent implements OnInit {
  public entrevista: Entrevista;

  constructor(private entrevistaService: EntrevistaService,
    private route: ActivatedRoute,
    private router: Router,
  ) {

    this.entrevista = new Entrevista();
  }

  getEntrevista(): void{
    this.route.params.forEach((params: Params) => {
     let id = params['id'];

     if (id !== undefined) {
       this.entrevistaService.getEntrevista(id)
         .then((entrevista) => this.entrevista = entrevista);
     }
   });

  }

  ngOnInit() {
    this.getEntrevista();
  }


}



// WEBPACK FOOTER //
// ./src/app/entrevista/entrevista.component.ts